import React, { createContext, useState } from 'react';

export const Modalv2Context = createContext();

// This is the modalv2 provider that wraps the entire application to provide modalv2 context
const Modalv2Provider = ({ children }) => {
	const [modalContent, setModalContent] = useState(null);
	const [blockClosingFeature, setBlockClosingFeature] = useState(false);

	const updateModalContent = (component) => {
		if (!blockClosingFeature) {
			setModalContent(component);
		}
	};

	return (
		<Modalv2Context.Provider
			value={{
				modalContent,
				updateModalContent,
				blockClosingFeature,
				updateBlockClosingFeature: setBlockClosingFeature
			}}
		>
			{children}
		</Modalv2Context.Provider>
	);
};
export default Modalv2Provider;
